export default "__VITE_ASSET__DnkaiMKc__"